import styled from 'styled-components';

import { ResizableTextarea } from '@r1-frontend/ui-react/experimental/forms';

export const Block = styled.div`
    display: block;
    width: 100%;
    
    ${ResizableTextarea} {
        width: 100%;
    }
`;

const DefaultWrapper = styled.div`
    display: flex;
    gap: 2px;
`;

export const DeliveryOptionsWrapper = styled(DefaultWrapper)`
    flex-direction: column;

    & > * {
        max-width: 314px;
    }
`;
